<script setup>
import SettingsLayout from "@/Layouts/Settings.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
//import { Inertia } from "@inertiajs/inertia";

const props = defineProps({
  office: Object,
  url: String,
  errors: Object,
});
//const canEdit = Inertia.page.props.auth.can["edit settings"];

function copyText(snippetnumber) {
  let el = document.getElementById("snippet" + snippetnumber);
  let txt = el.value;
  el.select();
  navigator.clipboard
    .writeText(txt)
    .then(() => {
      //alert(`Copied!`)
      let elconf = document.getElementById(
        "snippet" + snippetnumber + "-confirm"
      );
      // confirm and fade out
      elconf.style.opacity = 1;
      setTimeout(() => {
        var fadeEffect = setInterval(() => {
          if (elconf.style.opacity > 0) {
            elconf.style.opacity -= 0.01;
          } else {
            clearInterval(fadeEffect);
          }
        }, 10);
      }, 600);
    })
    .catch((error) => {
      alert(`Kopieren fehlgeschlagen! Benutzen Sie Strg+C zum kopieren.`);
    });
}
</script>

<template>
  <SettingsLayout>
    <Head title="Widget - Grundeinstellungen" />

    <template #breadcrumb>Widgeteinbindung</template>
    <template #controls>
      <HeaderLink href="/" type="close" class="mr-3">Schließen</HeaderLink>
    </template>

    <div class="flex flex-col h-full">
      <Heading title="Einbindung des Widget in Ihre Webseite" />

      <p class="max-w-2xl text-sm text-oteoText mb-8">
        Fügen Sie den folgenden Codeschnipsel vor dem &lt;/body&gt; Tag in die
        HTML ihrer Webseite ein.
      </p>

      <div class="mb-8 relative">
        <textarea
          rows="10"
          name="snippet1"
          id="snippet1"
          class="w-[800px] text-oteoText bg-oteoInputBG border-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm py-2"
          readonly
        >&lt;!--Start of spitta oteo Script--&gt;
&lt;script type="text/javascript"&gt;
    (function(){
        var key="{{ props.office.widgetkey }}",eid="spitta-oteo-widget",
        a=document.createElement("script"),b=document.getElementsByTagName("script")[0];
        a.async=!0,a.src="{{ props.url }}/widget/"+key+"?eid="+eid,
        a.charset="UTF-8",a.setAttribute("crossorigin","*"),b.parentNode.insertBefore(a,b)
    })()
&lt;/script&gt;
&lt;!--End of spitta oteo Script--&gt;</textarea
        >

        <button
          class="widget-copybtn px-3 py-1 text-sm font-semibold rounded-sm text-white bg-oteo-300 hover:opacity-70 cursor-pointer"
          @click="copyText(1)"
        >
          Kopieren
        </button>
        <div
          id="snippet1-confirm"
          class="bg-teal-100 rounded-b text-sm font-semibold text-teal-900 px-3 py-1"
        >
          Text kopiert!
        </div>

        <div class="mt-2 text-red-600 text-sm" v-if="errors.snippet">
          {{ errors.snippet }}
        </div>
      </div>

      <p class="max-w-2xl text-sm text-oteoText mb-8">
        Fügen Sie anschließend das folgende Element an der Stelle in die HTML
        ihrer Webseite ein, wo das Widget angezeigt werden soll.
      </p>

      <div class="mb-8 relative">
        <textarea
          rows="1"
          name="snippet2"
          id="snippet2"
          class="w-[800px] text-oteoText bg-oteoInputBG border-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm py-2"
          readonly
        >&lt;div id="spitta-oteo-widget"&gt;&lt;/div&gt;</textarea
        >

        <button
          class="widget-copybtn px-3 py-1 text-sm font-semibold rounded-sm text-white bg-oteo-300 hover:opacity-70 cursor-pointer"
          @click="copyText(2)"
        >
          Kopieren
        </button>
        <div
          id="snippet2-confirm"
          class="bg-teal-100 rounded-b text-sm font-semibold text-teal-900 px-3 py-1"
        >
          Text kopiert!
        </div>

        <div class="mt-2 text-red-600 text-sm" v-if="errors.snippet">
          {{ errors.snippet }}
        </div>
      </div>

      <Heading
        title="Verlinken auf das Widget 'Online-Terminvergabe' als
      eingebettete externe Seite"
      />

      <p class="max-w-2xl text-sm text-oteoText mb-8">
        Wenn Sie das Widget nicht direkt in Ihre Praxis-Webseite einbinden
        möchten, können Sie zur Verwendung des Widgets alternativ auf die
        eingebettete Seite verlinken. Der Link lautet:
      </p>

      <div class="mb-8 relative">
        <textarea
          rows="1"
          name="snippet3"
          id="snippet3"
          class="w-[800px] text-oteoText bg-oteoInputBG border-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm py-2"
          readonly
        >https://spitta-oteo.com/widget/iframe/step1/{{
            props.office.widgetkey
          }}</textarea
        >

        <button
          class="widget-copybtn px-3 py-1 text-sm font-semibold rounded-sm text-white bg-oteo-300 hover:opacity-70 cursor-pointer"
          @click="copyText(3)"
        >
          Kopieren
        </button>
        <div
          id="snippet3-confirm"
          class="bg-teal-100 rounded-b text-sm font-semibold text-teal-900 px-3 py-1"
        >
          Text kopiert!
        </div>

        <div class="mt-2 text-red-600 text-sm" v-if="errors.snippet">
          {{ errors.snippet }}
        </div>
      </div>
      <!-- 
      <div class="mb-8 relative">
        <p class="max-w-2xl text-sm text-oteoText mb-8">
          <a
            :href="`https://spitta-oteo.com/widget/iframe/step1/${props.office.widgetkey}`"
            target="_blank"
            >https://spitta-oteo.com/widget/iframe/step1/{{
              props.office.widgetkey
            }}</a
          >
          <button
            class="widget-copybtn !-my-1 px-3 py-1 text-sm font-semibold rounded-sm text-white bg-oteo-300 hover:opacity-70 cursor-pointer"
            @click="copyText(3)"
          >
            Kopieren
          </button>
        </p>
      </div> -->
    </div>
  </SettingsLayout>
</template>

<style>
.widget-copybtn {
  position: absolute;
  margin-top: 7px;
  margin-left: -5px;
  top: 0;
  left: 800px;
  transform: translateX(-100%);
}
#snippet1-confirm,
#snippet2-confirm,
#snippet3-confirm {
  opacity: 0;
  pointer-events: none;
  position: absolute;
  margin-top: 7px;
  margin-left: -2px;
  top: 0;
  left: 800px;
  transform: translateX(-100%);
}
</style>
